<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <app-print-button       
            matTooltip="Export to Excel" 
            matTooltipPosition="left" 
            matTooltipClass="custom-orange-tooltip"
            (click)="print()" 
        >
        </app-print-button>
    </app-tab-header>
    <div class="flex flex-col gap-2 px-5">  
        <div class="flex justify-start items-center">
            <span>
                <p class="uppercase violet-text underline text-xl font-extrabold text-dropshadow">Select Provider</p>
            </span>
        </div>
        <div>
            <div class="flex flex-col gap-4">
                <div class="w-550-px">
                    <app-custom-dropdown-v2
                        label="Provider:"
                        labelWidth="160px"
                        [options]="providerOptions"
                        [selectedText]="provider_text || ''"
                        placeholder="== Select an Option =="
                        (selectionChange)="setProvider($event.label, $event.value)">
                    </app-custom-dropdown-v2>
                </div>
                <div class="flex items-center">
                    <button (click)="switchLoadProvider()" 
                        appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                        matTooltip 
                        class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2"
                    >
                        submit
                    </button>
                </div>
                <app-toggle-add-btn
                    label="Add Buy Load SKU"
                    icon="add_circle"
                    permission="megapay.skusBillers.buyLoad.edit"
                    (clicked)="openCreateDialog()"
                />
            </div>
        </div>
    </div>
    <div style="margin-top: -1.5rem;">
        <app-table-controls
            [currentLimit]="size"
            [searchPlaceholder]="'Search buy load items'"
            (limitChangeEvent)="onLimitChangeFromComponent($event)"
            (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
            (keydownEvent)="keyDownFunction($event)"
        ></app-table-controls>
    </div>
    <app-data-table
        [tableHeader]="tableHeader"
        [tableSubHeader]="tableSubHeader"
        [isLoading]="isLoading"
        [sort_type]="sort_type"
        (toggleOnSort)="sortList($event.key, $event.type)"
    >
        <tr class="focus:outline-none" *ngFor="let buyLoad of buyLoad_lists">
            <td class="text-center">{{ buyLoad.itemName | nullWithDefault }}</td>
            <td class="text-center" *ngIf="buyLoad.itemType | nullWithDefault ">
                <p *ngIf="buyLoad.itemType===1">Promo</p>
                <p *ngIf="buyLoad.itemType===2">Load</p>
                <p *ngIf="buyLoad.itemType===3">Text</p>
                <p *ngIf="buyLoad.itemType===4">Combo</p>
                <p *ngIf="buyLoad.itemType===5">Meralco</p>
                <p *ngIf="buyLoad.itemType===6">Cignal</p>
                <p *ngIf="buyLoad.itemType===7">Cignal PPV</p>
                <p *ngIf="buyLoad.itemType===8">Gaming Pins</p>
                <p *ngIf="buyLoad.itemType===9">Entertainment</p>
                <p *ngIf="buyLoad.itemType===10">N/A</p>
            </td>
            <td class="text-center">{{ buyLoad.itemId | nullWithDefault }}</td>
            <td class="text-center">{{ buyLoad.itemCategory | nullWithDefault }}</td>
            <td class="text-center">{{ buyLoad.itemDesc | nullWithDefault }}</td>
            <td class="text-center">{{ buyLoad.itemPrice / 100 | number:'1.2-2' }}</td>
            <td class="text-center">{{ buyLoad.pointsAmount | number:'1.2-2' | nullWithDefault}}</td>
            <td class="text-center">
                <p>{{ buyLoad.redeemable ? 'YES' : 'NO' | nullWithDefault}}</p>
            </td>
            <td class="text-center" *ngIf="buyLoad.provider | nullWithDefault">
                <p *ngIf="buyLoad.provider===0"> Default (Resound for Globe, Digilink for Smart/Sun/TNT)</p>
                <p *ngIf="buyLoad.provider===1"> Digilink (Digilink For All Network)</p>
                <p *ngIf="buyLoad.provider===2"> Resound (Resound For All Network)</p>
            </td>
            <td class="text-center" *ngIf="buyLoad.providerType | nullWithDefault ">
                <p *ngIf="buyLoad.providerType===1">Smart</p>
                <p *ngIf="buyLoad.providerType===2">Globe</p>
                <p *ngIf="buyLoad.providerType===3">Sun</p>
                <p *ngIf="buyLoad.providerType===4">TNT</p>
                <p *ngIf="buyLoad.providerType===5">Smart Bro</p>
                <p *ngIf="buyLoad.providerType===6">Kuryente Load</p>
                <p *ngIf="buyLoad.providerType===7">Cignal</p>
                <p *ngIf="buyLoad.providerType===8">DITO</p>
                <p *ngIf="buyLoad.providerType===9">TM</p>
                <p *ngIf="buyLoad.providerType===10">SatLite</p>
                <p *ngIf="buyLoad.providerType===11">Cignal Play TV</p>
                <p *ngIf="buyLoad.providerType===12">Cignal HD Kit</p>
            </td>
            <td class="text-center">{{ buyLoad.rebatePercentage ?? 0 }}%</td>
            <td class="text-center">{{ buyLoad.sort | nullWithDefault}}</td>
            <td class="text-center">{{ buyLoad.status === 0 ? 'Active' : 'Inactive' }}</td>
            <td class="text-center">{{buyLoad.imageUrl | nullWithDefault}}</td>
            <td class="text-xs text-center">
                <div class="flex items-center space-x-3">
                    <button 
                        appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                        matTooltip
                        class="power-btn2 active" *ngIf="buyLoad.status===0" (click)="disable(buyLoad.uid, 1)"
                    >
                    Enabled
                    </button>
                    <button 
                        appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                        matTooltip
                        class="power-btn2" *ngIf="buyLoad.status===1" (click)="enable(buyLoad.uid, 0)"
                    >
                    Disabled
                    </button>
                    <button 
                        appDisableWithoutPermission="megapay.skusBillers.buyLoad.edit"
                        matTooltip
                        class="action-btn-blue2 custom-btn" (click)="openEditDialog(buyLoad.uid)"
                    >
                    Edit
                    </button>
                </div>
            </td>
        </tr>
    </app-data-table>
    <app-pagination
        [currentPage]="current_page"
        [totalPages]="total_pages"
        [pageSize]="size"
        [totalItems]="total"
        (pageChange)="setPage($event)"
        (previousPage)="prevPage()"
        (nextPage)="nextPage()"
        [showTotalEntries]="true"
    ></app-pagination>
</div>


<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>
